import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'
import { planPrice } from 'common/utils/planPrice'

const defaultStrings = {
  accessToMixer: 'Access to “The Mixer” – Our great networking event',
  accessToMixerDescription:
    'Access to "The Mixer" and "The Collective" – Work with our amazing customers including Unilever, Barclays, Visa, World Federation of Advertisers & BP.',
  airConditioning: 'Air conditioning',
  airConditioningDescription:
    'Icy-cold air-conditioning throughout the building.',
  allUtilitiesIncluded: 'All utilities included',
  allUtilitiesIncludedDescription: 'All utilities included',
  communityManager: 'Community Manager',
  communityManagerDescription:
    'Our onsite community manager is committed to supporting The Hoxton Mix community in every possible way.',
  ergonomicSeating: 'Ergonomic seating',
  ergonomicSeatingDescription:
    'Ergonomic seating and lockable storage at each desk.',
  filterCoffee: 'Filter coffee & tea provided free of charge',
  filterCoffeeDescription:
    'Keep caffeinated throughout the day or into the early hours with unlimited Pact freshly roasted coffee.',
  flexibleTerms: 'Flexible terms – Month-to-month',
  flexibleTermsDescription:
    'Flexibility and the right fit is important when it comes to finding an office space, our coworking plans are based on monthly payments and can be cancelled with one month’s notice.',
  fullServicedKitchen:
    'Full serviced kitchen – Dishwasher, microwave and fridge',
  fullServicedKitchenDescription:
    'Kitchens offer complimentary refreshments including fresh fruit, a stocked beer fridge and freshly roasted coffee.',
  fullyEquipped: 'Fully-equipped meeting room – Completely Free access',
  fullyEquippedDescription:
    'Modern meeting room table & furniture. Bright and spacious meeting room accommodates 6 people comfortably. The perfect setting for a meeting, interview or board meeting.',
  heroSubtitle: 'The perfect melting pot for a growing business',
  heroTitle: 'Hot Desks & Coworking Space in London',
  hotDeskAndCoWorking: 'Hot Desks & Coworking',
  hotDeskAndCoWorkingDescription:
    '<strong>Membership includes Access 24×7×365</strong>. Desks come with an ergonomic chair, pedestal and cupboard space for storage. Internet access both wired and wireless through our high-speed Fibre Optic Broadband. You will also be able to receive post to this address and meeting room usage is included. Membership is month-to-month, so there is no long-term commitment. Filter coffee & tea provided free of charge.',
  hotDeskPrice: `${planPrice.monthly['hot-desk-coworking']} pcm`,
  hotDeskPriceDuration:
    'Per month + VAT <br class="d-lg-none"/> <span class="d-lg-inline d-none">|</span> Access 24×7×365',
  keyFob: 'Key fob entry system – Video display',
  keyFobDescription:
    'We have CCTV, security alarms and a secure video entry system.',
  membershipAccess: `Access to our offices is 24/7/365 <br class="d-lg-block d-none">Full time Membership – <br class="d-xxl-block d-sm-none">${planPrice.monthly['hot-desk-coworking']} pcm + VAT`,
  membershipAccessDescription: 'Building Amenities',
  membershipContactUs:
    'Community management is committed to supporting your business in every possible way.',
  membershipDescription:
    'A coworking space in Shoreditch that’s designed with growth in mind. Work from flexible hot desks. Growing fast? Expand into a private office. <br class="d-lg-none"/> We’ve got you covered.',
  pluginAndJoin: 'Plug in and join <br class="d-sm-none"/> our community.',
  pluginAndJoinDescription: `<span class="color-black1 text-semibold">Creativity starts with the sharing <br class="d-sm-none"/> of ideas</span>. Working in an environment where you can bounce ideas <br class="d-xxl-block d-none"/> off each other leads to increased innovation and access to new business leads.
<br/><br/>Be part of the digital hub and get access to a plethora of creative and technical talent right in the <br class="d-sm-none"/> same location.`,
  seoBecomeAPartnerDescription:
    'Do you want to be listed? Fill out the form below to get in touch with our partnership team.',
  seoBecomeAPartnerTitle: 'Become a partner',
  seoMembershipDescription:
    'The Hoxton Mix co-working & private offices in the heart of Shoreditch. Beautiful workspaces, meeting rooms, fully furnished on flexible and competitive terms.',
  seoMembershipTitle:
    'Amazing Co-working and Office Space in Shoreditch, London',
  turnUpPlugIn: 'Just turn up and plug in…',
  turnUpPlugInDescription:
    'Just turn up, plug in and grow your company with The Hoxton Mix.',
  virtualPhoneNumberThatTravelsWithYou:
    'A virtual phone number that travels with you.',
  wetRoom: 'Wet room shower',
  wetRoomDescription:
    'For those who jog or bike to work or enjoy a gruelling morning workout, you can freshen yourself up in one of the onsite wetrooms.',
  wirelessEthernet: 'Wireless & ethernet broadband – Fibre Optic Broadband',
  wirelessEthernetDescription:
    'Dedicated leased line with the latest in high speed WiFi technology.',
}
export const membershipStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
